export default "__VITE_ASSET__Brnv0a9i__"